import { render, staticRenderFns } from "./MyPageTemplate.vue?vue&type=template&id=727684c2"
import script from "./MyPageTemplate.vue?vue&type=script&lang=js"
export * from "./MyPageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports